export default "__VITE_PUBLIC_ASSET__8240d68a__"